import CustomAccordian from "../../components/CustomAccordian";
import CustomButton from "../../components/CustomButton";
import { useState } from "react";
import '../../assets/css/SearchFilter.css';
import { useNavigate } from "react-router-dom";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import MultiRangeSlider from "multi-range-slider-react";
import { useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { saveFilterGameUpdating, saveFilterUpdating } from "../../redux/UserDataSlice";
import FilterLocation from "../../components/FilterLocation";


const GameSearchFilter = ({ onCloseFilterModal, onCloseModal, onSelectedSport, notShowfilterBySport }) => {
    const [location, setLocation] = useState({ latitude: null, longitude: null });
    const [distance, setDistance] = useState(100);
    const [isSearchForStringer, setIsSearchForStringer] = useState(false);
    const { accessToken } = useSelector((state) => state.loginInfo);
    const [profileLocation, setProfileLocation] = useState();
    const [currentLocation, setCurrentLocation] = useState();
    const [otherLocation, setOtherLocation] = useState();
    const [locationResults, setLocationResults] = useState([]);

    const { profileData, filterUpdating, filterGameUpdating } = useSelector((state) => state.loginInfo);
    const dispatch = useDispatch();


    const handleDistanceChange = (e) => {
        setDistance(e.target.value);
    };

    const [selectedLevels, setSelectedLevels] = useState([]);
    const [selectedLevelSpotrs, setSelectedLevelSports] = useState();
    const [selectedLevelGender, setSelectedLevelGender] = useState()

    const [minValue, setMinValue] = useState(25);
    const [maxValue, setMaxValue] = useState(75);
    const [minValue2, setMinValue2] = useState(0);
    const [maxValue2, setMaxValue2] = useState(100);
    const [selectedLocation, setSelectedLocation] = useState("Profile Location");
    const [loading, setLoading] = useState();

    const levels = [
        'BEGINNER',
        'INTERMEDIATE',
        'UPPER-INTERMEDIATE',
        'PROFICIENT',
        'LEAGUE-PLAYER'
    ];
    const sports = [
        'Tennis',
        'Pickle Ball'
    ];
    const genders = [
        'MALE',
        'FEMALE',
        'OTHERS'
    ];


    const onApplyFilter = () => {
        if (!selectedLevelSpotrs || selectedLevelSpotrs.length === 0) {
            toast.error("Please select a sport before applying the filter");
            return;
        }
        const payload = {
            "longitude": location.longitude,
            "latitude": location.latitude,
            'maxDistance': parseFloat(distance) * 1609.34,
            "sportName": selectedLevelSpotrs,
            'skillLevel': selectedLevels.some(level => level.includes('-')) ? selectedLevels.map(level => level.replace(/-/g, '_')) : selectedLevels,

            "gender": selectedLevelGender,
            "minAge": minValue2,
            "maxAge": maxValue2
        }
        const userSearchFilter = async () => {
            setLoading(true);
            try {
                const result = await apiHandler({
                    url: endpoint.USER_SEARCH_FILTER,
                    method: "POST",
                    data: payload,
                    authToken: accessToken?.accessToken
                });
                if (result.data) {
                    dispatch(saveFilterUpdating(!filterUpdating));
                    onCloseFilterModal(true);
                    toast.success(result?.data?.message)
                }
                else {
                    toast.error("Something went wrong please try again")
                }
            } catch (error) {
                toast.error("Something went wrong please try again")
            }
            setTimeout(() => setLoading(false), 3000);
        };
        userSearchFilter();
    }

    const handleCheckboxChange = (level) => {
        setSelectedLevels(prevSelected => {
            if (prevSelected?.includes(level)) {
                return prevSelected?.filter(item => item !== level);
            } else {
                return [...prevSelected, level];
            }
        });
    };

    const handleCheckboxChangeSports = (level) => {
        console.log('level', level)
        setSelectedLevelSports((prevSelected) =>
            prevSelected === level ? null : level
        );
    };

    const handleCheckboxChangeGender = (level) => {
        setSelectedLevelGender((prevSelected) => {
            if (Array.isArray(prevSelected)) {
                const newState = prevSelected.includes(level)
                    ? prevSelected.filter((item) => item !== level)
                    : [...prevSelected, level];

                console.log("New State:", newState);
                return newState;
            }
            return [level];
        });
    };

    const getLocationName = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                const address = data.results[0]?.formatted_address;
                console.log('Location:', address);
                return address;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            return null;
        }
    };

    const onLocationChange = (selectlocation) => {
        setLocation(selectlocation)
    }

    useEffect(() => {
        if (navigator?.geolocation) {
            navigator?.geolocation?.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position?.coords;
                    localStorage.setItem("coordinates", JSON.stringify({ latitude, longitude }));
                    getLocationName(latitude, longitude)
                        .then((address) => {
                            setCurrentLocation(address)
                        });
                },
                (error) => {
                    console.error('Error fetching location:', error);
                }
            );
        }
    }, [])

    useEffect(() => {
        const fetchLocation = async () => {
            if (otherLocation?.length >= 3) {
                try {
                    const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                        params: {
                            address: otherLocation,
                            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                        }
                    });

                    if (response.data.results && response.data.results.length > 0) {
                        const locations = response.data.results.map(result => ({
                            name: result.formatted_address,
                            lat: result.geometry.location.lat,
                            lng: result.geometry.location.lng
                        }));
                        setLocationResults(locations);
                    } else {
                        setLocationResults([]);
                    }
                } catch (error) {
                    console.error('Error fetching location:', error);
                }
            } else {
                setLocationResults([]);
            }
        };

        const delayDebounceFn = setTimeout(fetchLocation, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [otherLocation]);

    useEffect(() => {
        getLocationName(profileData?.baseProfile?.latitude, profileData?.baseProfile?.longitude)
            .then((address) => {
                setProfileLocation(address)
            });
        switch (selectedLocation) {
            case 'Profile Location':
                setLocation({ latitude: profileData?.baseProfile?.latitude, longitude: profileData?.baseProfile?.longitude })
                break;

            case 'Current Location':
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const { latitude, longitude } = position.coords;
                            getLocationName(latitude, longitude)
                                .then((address) => {
                                    setCurrentLocation(address)
                                });
                            setLocation({ latitude: latitude, longitude: longitude })
                        },
                        (error) => {
                            console.error('Error fetching location:', error);
                        }
                    );
                }
                break;

            case 'Other':
                // console.log('Other Location Selected - user needs to enter a location');
                break;

            default:
                // console.log('No location selected');
                break;
        }
    }, [selectedLocation]);

    useEffect(() => {
        const fetchProfileFilterData = async () => {
            setLoading(true);
            try {
                const result = await apiHandler({
                    url: endpoint.FETCH_PROFILE_FILTER_DATA,
                    method: "GET",
                    authToken: accessToken?.accessToken
                });

                if (result.data) {

                    setLocation({
                        latitude: result.data.latitude,
                        longitude: result.data.longitude
                    });
                    const apiLat = result.data.latitude;
                    const apiLng = result.data.longitude;
                    const storedCoordinates = JSON.parse(localStorage.getItem("coordinates"));

                    setLocation({ latitude: apiLat, longitude: apiLng });
                    if (
                        apiLat === profileData?.baseProfile?.latitude &&
                        apiLng === profileData?.baseProfile?.longitude
                    ) {
                        setSelectedLocation("Profile Location");
                    } else if (

                        apiLat === storedCoordinates?.latitude &&
                        apiLng === storedCoordinates?.longitude
                    ) {
                        setSelectedLocation("Current Location");
                    } else {
                        setSelectedLocation("Other");
                    }
                    { console.log(' result.data.maxDistance', result.data.maxDistance) }
                    result.data.maxDistance && setDistance(parseFloat(result.data.maxDistance / 1609.34).toFixed(2))
                    onSelectedSport(result.data.sportName)
                    setSelectedLevelSports(result.data.sportName);
                    if (Array.isArray(result.data.skillLevel)) {
                        const formattedSkillLevels = result.data.skillLevel.map(level => level.replace(/_/g, '-'));
                        setSelectedLevels(formattedSkillLevels);
                    } else if (typeof result.data.skillLevel === 'string') {
                        setSelectedLevels([result.data.skillLevel.replace(/_/g, '-')]);
                    } else {
                        setSelectedLevels([]);
                    }

                    if (Array.isArray(result.data.gender)) {
                        setSelectedLevelGender(result.data.gender);
                    } else if (typeof result.data.gender === 'string') {
                        setSelectedLevelGender([result.data.gender]);
                    } else {
                        setSelectedLevelGender([]);
                    }

                    setMinValue2(result.data.minAge ?? 0);
                    setMaxValue2(result.data.maxAge ?? 100);
                }
            } catch (error) {
                console.error("Error fetching filter data", error);
            }

            setTimeout(() => setLoading(false), 3000);
        };
        fetchProfileFilterData();
        dispatch(saveFilterGameUpdating(!filterGameUpdating))
    }, [filterUpdating, accessToken]);

    const accordionItems = [
        {
            title: ' Filter By Location & Distance',
            content:
                <div className="container mt-4  p-sm-4 border rounded">
                    <FilterLocation onLocationChange={onLocationChange} />
                    <h5 className="fw-bold mt-4">Distance</h5>
                    <div className="d-flex align-items-center">
                        <input
                            type="range"
                            className="form-range-single "
                            min="0"
                            max="100"
                            value={distance}
                            onChange={handleDistanceChange}
                        />
                        <span className="ms-2 badge bg-primary">{distance}</span>
                    </div>
                </div>,
        },
        {
            title: ' Filter By Levels',
            content: <div className="card shadow-sm">
                <div className="card-body">
                    <h5 className="card-title mb-3">Levels</h5>
                    <form>
                        {levels?.map((level) => {
                            const formattedLevel = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
                            return (
                                <div key={level} className="form-check mb-2 pb-1">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`level-${level}`}
                                        checked={selectedLevels?.includes(level)}
                                        onChange={() => handleCheckboxChange(level)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`level-${level}`}
                                    >
                                        {formattedLevel}
                                    </label>
                                </div>
                            );
                        })}
                    </form>
                </div>
            </div>,
        },

        ...(notShowfilterBySport == undefined
            ? [
                {
                    title: 'Filter By Sports',
                    content: (
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title mb-3">Sports</h5>
                                <form>
                                    {sports?.map((level) => {
                                        const formattedLevel = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
                                        return (
                                            <div key={level} className="form-check mb-2">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`level-${formattedLevel}`}
                                                    checked={selectedLevelSpotrs?.includes(level)}
                                                    onChange={() => handleCheckboxChangeSports(level)}
                                                />
                                                <label className="form-check-label" htmlFor={`level-${formattedLevel}`}>
                                                    {formattedLevel}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </form>
                            </div>
                        </div>
                    ),
                },
            ]
            : []),
        {
            title: 'Filter By Gender',
            content: <div className="card shadow-sm" >
                <div className="card-body">
                    <h5 className="card-title mb-3">Gender</h5>
                    <form>
                        {genders?.map((level) => {
                            const formattedLevel = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
                            return (
                                <div key={level} className="form-check mb-2">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`level-${formattedLevel}`}
                                        checked={selectedLevelGender?.includes(level)}
                                        onChange={() => handleCheckboxChangeGender(level)}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`level-${formattedLevel}`}
                                    >
                                        {formattedLevel}
                                    </label>
                                </div>
                            );
                        })}
                    </form>

                </div>
            </div>,
        },
        {
            title: 'Filter By Age Range',
            content:
                <>
                    <div className="container mt-4">
                        <h5 className="age-txt">Age Range</h5>
                        <MultiRangeSlider
                            baseClassName="multi-range-slider-black"
                            minValue={minValue}
                            maxValue={maxValue}
                            onInput={(e) => {
                                setMinValue(e.minValue);
                                setMaxValue(e.maxValue);
                            }}
                            onChange={(e) => {
                                setMinValue2(e.minValue);
                                setMaxValue2(e.maxValue);
                            }}
                        />
                    </div>
                    <div className="d-flex justify-content-between w-100 mt-3">
                        <div className="age-input">{minValue2} yr</div>
                        <div className="age-input">{maxValue2} yr</div>
                    </div>
                </>,
        },
    ];
    const onCancelFilter = async () => {
        try {
            setLoading(true);
            const result = await apiHandler({
                url: endpoint?.CANCEL_USER_FILTER,
                method: "POST",
                authToken: accessToken?.accessToken,
            });
            const response = result.data;
            if (response) {
                setLoading(false);
                onCloseFilterModal(true);
                toast.success(response.message || "Filter apply successfully")
            }
        } catch (error) {
            console.error("Error fetching players:", error);
        }
    }
console.log('notShowfilterBySport',notShowfilterBySport)
    return (
        <>
            <div className="row">
                <div className="d-flex justify-content-between ps-4 pe-4 pb-4 pt-4">
                    <div style={{ color: '#006FFD', fontWeight: '600', cursor: 'pointer' }} onClick={() => onCloseModal(true)}>Cancel</div>
                    <div style={{ color: '#1F2024', fontWeight: '600', cursor: 'pointer' }}>Filter</div>
                    <button style={{ color: '#FF616D', fontWeight: '600', cursor: 'pointer', background: 'none', border: 'none' }} onClick={() => onCancelFilter()} disabled={loading} >Clear All</button>
                </div>
                <div>
                    <CustomAccordian items={isSearchForStringer ? [accordionItems[0]] : accordionItems} />
                </div>
                <div className="pt-3 pb-2">
                    <CustomButton buttonText={'Apply Filter'} className="custom-search-filter-btn" onClick={onApplyFilter} disabled={loading} />
                </div>
            </div>
        </>
    )
}
export default GameSearchFilter;